import { Collections } from '../../firebase/firestore/collections';
import { useDocumentSnapshotWithLoading } from '../../firebase/firestore/hooks';
import { Accounts } from '../../firebase/firestore/documents/accounts';
import { useCurrentUserProfile } from './useCurrentUserProfile';

const useAccountsWithLoading = (): { account: Accounts | undefined; loading: boolean } => {
  const { currentUserProfile } = useCurrentUserProfile();
  const { data, loading } = useDocumentSnapshotWithLoading<Readonly<Accounts>>(Collections.ACCOUNT, currentUserProfile?.account);

  return { account: data, loading };
};

export default useAccountsWithLoading;
